"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DeepRelaxation() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}